module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fm-head"
  }, [_vm._v("ACKNOWLEDGEMENTS")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ESEARCH")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("James R. Bowsher, Jerry Pearson, Timothy Brian McKee, Brett Mitchell, James Dailey, Chris Woodyard, Michelle Jordan-Frias, Walt Bowsher, Boyd Addlesperger, Jayson Schlechty, Kenny Libben, Marie Herlevi, James Reed, Dr. Robert Berry, Joe and Pat Smith, Dr. Blake Wagner, Steve McQuown, Yolanda Campbell Lifter, Sherry Knight, Christine Rose, Chuck Salmons, Tyler A. Norris, Kelsey Denney, Mark Hersman, Dawn Shimp, Michelle Italia Walker, Julie Wittmer, Andrea Wittmer, Jim Stoner, Amie Lynn, Stephanie Bugg and Ginger Patterson.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RODUCTION")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Daniel J. Feiertag, Louis Andres, Steve and Debbie Kramer, Mary Ann Calhoun, Laura Callahan, Victoria Cochran, Dan and Sue Haeseker, Jim and Debbie Shade, Sybil Burskey and Lori Morey.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ROMOTIONAL")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Ed Gutchall, Tommy Barnes, Rusty Cates, Chelley Kemper, Jodi Snavely, Lee Tasseff, Jamie Kinton, Norm Narvaja, Beth Santore, Brittany Schock, Grant Pepper, Linette Porter, Mike and Christina Petee, Eric and Judy Defibaugh, Paul Smith, Gina Jessee, Leigh Ann Arnholt, Becky Avery, Lori Morey, David Fitzsimmons, Wendy Zarara, Joshua Andra, Beth Donaldson, Keli Dotson, Deborah Dubois, Mary Frankenfield, Kinsey Landin, Danica Perry, Natasha Waltz, Emily Menshouse and Debbie Smith.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ERSONAL")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Nancy Nixon, Jill and Andy Poloni, Bryan Gladden, Robin Greene, Annie Tarpley, Sharron Coeurvie, D’Aine Greene, Maysel Brooks, Jennifer Hurst, Jennifer Hunter, Will Cowman, Paige Nichol Jordan, Dr. Larry J. Evans, Steve Easterling, Llalan Fowler, Beth Wright-Archer, Chevy Bond, Victoria Hoefler, Tabitha Kennedy, Lucas Hargis, Amaliya Renock, Andy Nelson, Dan Hardwick, Brian Moore, Edward Lee Fox, Tommy Sarmiento and Lloyd and Violet Jordan.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NSTITUTIONS AND")]), _vm._v(" D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ATABASES")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Akron/Stark County Public Library; Cleo Redd Fisher Museum/Mohican Historical Society; Division of Forestry, Ohio Department of Natural Resources (ODNR); Division of Geological Survey, ODNR; John Sherman Room, Mansfield, Richland County Public Library; Lima State Hospital; Madison County Probate Court; Malabar Farm Foundation; Malabar Farm State Park; The Mansfield Playhouse; Mansfield Reformatory Preservation Society; Oakwood Correctional Institution; Ohio Department of Corrections; Ohio Genealogical Society; Ohio History Connection; The Ohio State University, Mansfield; Ohio Theatre Alliance; Richland County Foundation; Richland County Probate Court; "), _c('a', {
    attrs: {
      "href": "http://Rootsweb.com",
      "target": "_blank"
    }
  }, [_vm._v("Rootsweb.com")]), _vm._v("; and Rose Family Association.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-55a69a56","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Acknowledgments.vue
// module id = 75
// module chunks = 0